import { MenuPageHitV1 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';

export const MENU_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
  };

  return buildEvent({
    Event: MenuPageHitV1,
    payload: {
      universe: (payload?.universe || 'WOMAN') as 'WOMAN' | 'MAN' | 'KID',
    },
  });
};
